"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _of = require("rxjs/observable/of");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _startWith = require("rxjs/operators/startWith");

var _reactRouterRedux = require("react-router-redux");

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _actions = require("settings-ui-sdk/Blogs/actions");

var _newBlogActions = require("../actions/staging/newBlogActions");

var _newBlogSelectors = require("../selectors/staging/newBlogSelectors");

var _selectors = require("settings-ui-sdk/Auth/selectors");

function _default($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.CreateBlogActionTypes.SUCCESS).pipe((0, _map.map)(function (action) {
    return action.payload.data.id;
  }), (0, _mergeMap.mergeMap)(function (blogId) {
    var shouldImportExternalBlog = (0, _newBlogSelectors.getImportExternalBlog)(getState());

    if (shouldImportExternalBlog) {
      _Routes.default.init((0, _selectors.getUserGates)(getState()));

      window.location.href = _Routes.default.blogImporter();
    }

    return (0, _of.of)((0, _reactRouterRedux.push)("/website/blogs/" + blogId)).pipe((0, _startWith.startWith)((0, _newBlogActions.resetNewBlogStage)()));
  }));
}

module.exports = exports.default;